<template>
<base-dialog-modal
    :title="$t('seller.moveItemsTitle')"
    ref="itemsMoveModal">

	<div slot="modal-body">
		<div class="row">
			<div class="col">

                <div class="alert alert-danger" role="alert">
                     <strong>{{ $t('common.warning') }}</strong>

					<br>

					<i18n path="seller.moveItemsWarning" tag="p">
						<strong place="unsoldItems">{{ $t('seller.moveItemsUnsoldItems') }}</strong>
					</i18n>
                </div>

                {{ $t('seller.moveItemsQuestionAuction') }}

                <!-- Veiling List !-->
                <b-form-select v-model="selected" :options="options" class="mb-3">
                </b-form-select>
			</div>
		</div>
	</div>

	<div slot="modal-footer">
		<div class="row">
			<div class="col">
				<b-button class="mt-3"
				          type="button"
				          variant="outline-primary"
				          block
				          @click="onCancel">

					{{ $t('common.cancel') }}

				</b-button>
			</div>
			<div class="col">
				<b-button class="mt-3"
				          type="button"
				          v-bind:disabled="isMoving"
				          block
				          variant="outline-danger"
				          @click="onConfirm">

					<loader-spinner :text="$t('seller.moveItemsAction')"
					                :show-spinner="isMoving"></loader-spinner>

				</b-button>
			</div>
		</div>
	</div>
</base-dialog-modal>
</template>
<script>
import { isNil } from 'lodash';
import { mapGetters } from 'vuex';
import { flashSuccess, flashDanger } from '@/helpers/flash-message-helper';
import BaseDialogModal from '@/components/elements/Base/BaseDialogModal';
import LoaderSpinner from '@/components/elements/LoaderSpinner';
import ItemService from '@/services/item-service';


export default {
	components: {
		BaseDialogModal,
		LoaderSpinner
	},
	computed: {
		  ...mapGetters([
			'activeAuction',
			'auctions'
		]),
		options() {
			return this.auctions
				.filter(auction => auction.id !== this.activeAuction.id)
				.map(auction => ({ value: auction.id, text: auction.title }));
		}
	},
	data: () => ({
		selected: null,
		isMoving: false,
    }),
	methods: {
		/**
		 * Hide the modal
		 */
		hide() {
			this.$refs.itemsMoveModal.hide();
		},

		/**
		 * Show the modal
		 */
		show() {
			this.$refs.itemsMoveModal.show();
		},

		/**
		 * On cancel emit cancel event and hide modal
		 */
		onCancel() {
			this.$emit('cancel');
			this.hide();
		},

		/**
		 * On confirm emit confirm event with optional the item
		 */
		onConfirm() {

			if(this.selected == null) return;

			const params = this.$route.params;

			this.isMoving = true;

			ItemService.moveUnsoldItemsBySeller(params.auctionId, params.personId, this.selected)
				.then(() => {

					this.isMoving = false
					this.$emit('moved');
					this.hide();

					flashSuccess(this.$t('seller.moveItemsSuccess'));

				})
				.catch(this.onError);
		},

		/**
		 * On error display an error message and hide the modal
		 */
		onError(error) {
			this.isMoving = false;
			this.hide();
			flashDanger(this.$t('seller.moveItemsError'));
		}
	}
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// ItemsMoveModal.vue?517da55a